export enum MrCasMontage {
    PIECE_CHOICE = 'pieceChoice',
    ARTICLE_CODE_CHOICE = 'articleCodeChoice'
}
